import React from 'react'
import moment from 'moment'
import { COLORES } from '../../../config/colores'
import OperacionesCupo from '../containers/asignacionCupos/OperacionesCupoAsignado'
import TableValueAction from '../../MuiTable/components/TableValueAction'
import TablaConsultaCodigoDeCupos from '../containers/consultaCodigoDeCupos/containers/TablaConsultaCodigoDeCupos'

export function getColumnasCuposAsignados (roles = null) {
  const rolExportador = roles && roles.filter((rol) => rol === 'EXPORTADOR')
  const isExportador = rolExportador && rolExportador.length > 0

  const rolConsulta = roles.find((r) => r === 'EXPORTADOR_CONSULTA')
  const soloConsulta = !!rolConsulta

  return ([
    {
      name: 'fechaDeEmision',
      label: 'Fecha',
      options: {
        filter: true,
        sort: true,
        sticky: true,
        filterType: 'multiselect',
        customBodyRender: f => {
          moment.locale('ar-AR')
          // Los cupos son los vigentes, no es necesario mostrar el año
          const fecha = moment(f).format('DD/MM/YY')
          return <div>{fecha}</div>
        },
        setCellProps: () => ({
          style: {
            position: 'sticky',
            left: '0',
            background: COLORES.grey.light,
            zIndex: 100
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            left: 0,
            background: 'white',
            zIndex: 101
          }
        })
      }
    },
    {
      name: 'claveCereal',
      label: 'Cereal',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox'
      },
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: 15,
          background: COLORES.grey.light,
          zIndex: 120
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 15,
          background: 'white',
          zIndex: 121
        }
      })
    },
    {
      name: 'exportador',
      label: 'Exportador',
      options: {
        filter: true,
        sort: true,
        filterType: 'dropdown',
        display: !isExportador
      }
    },
    {
      name: 'tipo',
      label: 'Tipo',
      options: {
        filter: true,
        sort: true,
        customBodyRender: f => {
          const tipo = (f === 'Nominable' ? 'N' : 'L')
          return <div>{tipo}</div>
        }
      }
    },
    {
      name: 'entry',
      label: 'Asignados',
      options: {
        filter: false,
        sort: true,
        total: true,
        customBodyRender: (entry) => {
          const value = entry.cantidadAsignada
          const fechaFiltro = entry.fechaDeEmision
          const cerealFiltro = entry.claveCereal
          const filtroInicial = [
            {
              name: 'cereal',
              filterList: [cerealFiltro]
            },
            {
              name: 'fechaCupo',
              filterList: [fechaFiltro]
            },
            {
              name: 'exportador',
              filterList: [entry.exportador]
            }
          ]

          return (
            (value > 0)
              ? <TableValueAction
                value={value}
                title='Códigos de cupo asignados'
                content={<TablaConsultaCodigoDeCupos
                  showTitle={false}
                  filtroInicial={filtroInicial}
                  fechaFiltro={fechaFiltro}
                  cerealFiltro={cerealFiltro}
                />
                }
              />
              : <div style={{
                color: COLORES.grey.dark,
                fontSize: '1rem',
                width: '100%',
                fontWeight: 'bold'
              }}
              >
                {value}
              </div>
          )
        }
      }
    },
    {
      name: 'cantidadUsada',
      label: 'Utilizados',
      options: {
        filter: false,
        sort: true,
        total: true
      }
    },
    {
      name: 'cantidadDisponible',
      label: 'Disponibles',
      options: {
        filter: false,
        sort: true,
        total: true,
        customBodyRender: value => {
          let color
          if (value === 0) {
            color = COLORES.red.medium
          } else {
            if (value <= 10) {
              color = COLORES.blue.primary
            } else {
              color = COLORES.green.light
            }
          }
          return <div style={{ color: color, fontWeight: 'bold' }}>{value}</div>
        }
      }
    },
    {
      name: 'cupo',
      label: 'Operacion',
      options: {
        print: false,
        filter: false,
        sort: false,
        viewColumns: false,
        display: !soloConsulta,
        customBodyRender: value => {
          return <OperacionesCupo cupo={value} />
        }
      }
    },
    {
      name: 'habilitado',
      label: ' ',
      options: {
        print: false,
        filter: true,
        sort: false,
        viewColumns: false,
        filterType: 'checkbox',
        customBodyRender: value => {
          return <> </>
        }
      }
    }
  ])
}

export const CUPOS_ASIGNADOS_TO_PRINT = [
  {
    name: 'fechaDeEmision',
    label: 'Fecha',
    width: '80'
  },
  {
    name: 'claveCereal',
    label: 'Cereal',
    width: '80'
  },
  {
    name: 'exportador',
    label: 'Exportador',
    width: '100'
  },
  {
    name: 'tipo',
    label: 'Tipo',
    width: '50'
  },
  {
    name: 'cantidadAsignada',
    label: 'Asignados',
    width: '80'
  },
  {
    name: 'cantidadUsada',
    label: 'Utilizados',
    width: '80'
  },
  {
    name: 'cantidadDisponible',
    label: 'Disponibles',
    width: '80'
  }
]

export function columnasCuposAsignados () {
  let columns = []
  columns = [
    {
      name: 'fechaDeCupoDate',
      label: 'Fecha',
      options: {
        filter: true,
        sort: true,
        filterType: 'multiselect',
        customBodyRender: f => {
          moment.locale('ar-AR')
          const fecha = moment(f).format('DD/MM/YY')
          return <div>{fecha}</div>
        },
        setCellProps: () => ({
          style: {
            position: 'sticky',
            left: '0',
            background: COLORES.grey.light,
            zIndex: 100
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            left: 0,
            background: 'white',
            zIndex: 101
          }
        })
      }
    }
  ]

  columns.push({
    name: 'claveCereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  })

  return columns
}

export const COLUMNS_CUPOS_HISTORICOS = [
  {
    name: 'fechaDeEmisionDate',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: f => {
        moment.locale('ar-AR')
        const fecha = moment(f).format('DD/MM/YY')
        return <div>{fecha}</div>
      },
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'claveCereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'exportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'dropdown'
    }
  },
  {
    name: 'tipo',
    label: 'Tipo',
    options: {
      filter: true,
      sort: true,
      customBodyRender: f => {
        const tipo = (f.toLowerCase() === 'nominable' ? 'N' : 'L')
        return <div>{tipo}</div>
      }
    }
  },
  {
    name: 'cantidadAsignada',
    label: 'Asignados',
    options: {
      filter: false,
      sort: true,
      total: true
    }
  },
  {
    name: 'cantidadUsada',
    label: 'Utilizados',
    options: {
      filter: false,
      sort: true,
      total: true
    }
  },
  {
    name: 'cantidadDisponible',
    label: 'Sin utilizar',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: value => {
        return <>{value <= 0 ? <div> - </div> : value}</>
      }
    }
  }
]

export const COLUMNS_CUPOS_HISTORICOS_EXPORTADOR = [
  {
    name: 'fechaDeEmisionDate',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: f => {
        moment.locale('ar-AR')
        const fecha = moment(f).format('DD/MM/YY')
        return <div>{fecha}</div>
      },
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'claveCereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'tipo',
    label: 'Tipo',
    options: {
      filter: true,
      sort: true,
      customBodyRender: f => {
        const tipo = (f.toLowerCase() === 'nominable' ? 'N' : 'L')
        return <div>{tipo}</div>
      }
    }
  },
  {
    name: 'cantidadAsignada',
    label: 'Asignados',
    options: {
      filter: false,
      sort: true,
      total: true
    }
  },
  {
    name: 'cantidadUsada',
    label: 'Utilizados',
    options: {
      filter: false,
      sort: true,
      total: true
    }
  },
  {
    name: 'cantidadDisponible',
    label: 'Sin utilizar',
    options: {
      filter: false,
      sort: true,
      customBodyRender: value => {
        return <>{value <= 0 ? <div> - </div> : value}</>
      }
    }
  }
]

export const COLUMNS_TOTAL_CUPOS_VIGENTES = [
  {
    name: 'fechaDeEmision',
    label: 'Fecha de cupo',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: f => {
        moment.locale('ar-AR')
        const fecha = moment(f).format('DD/MM/YY')
        return <div>{fecha}</div>
      }
    }
  },
  {
    name: 'cantidadAsignada',
    label: 'Asignados',
    options: {
      filter: false,
      sort: true,
      customBodyRender: cantidad => {
        return <div style={{ fontWeight: 'bold' }}>{cantidad}</div>
      }
    }
  },
  {
    name: 'cantidadUsada',
    label: 'Utilizados',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'cantidadDisponible',
    label: 'Sin utilizar',
    options: {
      filter: false,
      sort: true,
      customBodyRender: value => {
        return <>{value <= 0 ? <div> - </div> : value}</>
      }
    }
  }
]
